// Libs
import api from "../../api";
import { Helmet } from "react-helmet";

// Components
import { BlogCard } from "../../components/BlogCard/BlogCard";
import { LoadingFallback } from "../../components/LoadingFallback/LoadingFallback";
import { View } from "../../containers/view/View";

// Utils
import { Blog } from "../../models/Blog";
import { previewImage } from "../../constants";

import { useEffect, useState } from "react";
import styles from "./AdvicesPage.module.scss";

export const AdvicesPage: React.FunctionComponent = () => {
  const [posts, setPosts] = useState<Blog[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchPosts = async () => {
    setLoading(true);
    try {
      const response = await api.blogs.fetchBlogs("5");
      const data = await response.json();
      if (response.status === 200) {
        setPosts(data);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  return (
    <View
      title="Korisni savjeti"
      description="Iskoristite priliku i saznajte šta treba da znate ako tražite posao ili promjenu posla."
    >
      <Helmet>
        <title>Korisni savjeti | Agencija Spektar</title>
        <meta name="description" content="Agencija Spektar" />
        <meta
          property="og:title"
          content="Korisni savjeti | Agencija Spektar"
        />
        <meta property="og:site_name" content="Agencija Spektar" />
        <meta property="og:image" content={previewImage} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
      </Helmet>

      <View.Content>
        <div className={styles.cards}>
          {loading && <LoadingFallback />}
          {!loading && posts.length === 0 ? (
            <p style={{ margin: "auto", marginTop: "20vh" }}>
              Nisu pronađene nove objave.
            </p>
          ) : (
            posts.map((e) => {
              return <BlogCard blog={e} key={e.id} />;
            })
          )}
        </div>
      </View.Content>
    </View>
  );
};
